export const SEARCH_PROSPECTS = 'SEARCH_PROSPECTS';
export const MERGE_PROSPECTS = 'MERGE_PROSPECTS';
export const REVIEW_PROSPECTS = 'REVIEW_PROSPECTS';
export const LOAD_CITIZENSHIP = "LOAD_CITIZENSHIP";
export const MASTER_RECORD = "MASTER_RECORD";
export const CHILD_RECORD = "CHILD_RECORD";
export const ALLOW_PROSPECTS = "ALLOW_PROSPECTS";
export const SELECTED_MERGE_PROSPECTS = "SELECTED_MERGE_PROSPECTS";
export const SELECTED_MASTER_PROSPECTS ="SELECTED_MASTER_PROSPECTS";
export const SEARCH_PROSPECTS_MERGE ="SEARCH_PROSPECTS_MERGE"